var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedirect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 2H11.375C11.859 2 12.25 2.39102 12.25 2.875V9.875C12.25 10.359 11.859 10.75 11.375 10.75H9.625C9.14102 10.75 8.75 11.141 8.75 11.625C8.75 12.109 9.14102 12.5 9.625 12.5H11.375C12.8242 12.5 14 11.3242 14 9.875V2.875C14 1.42578 12.8242 0.25 11.375 0.25H9.625C9.14102 0.25 8.75 0.641016 8.75 1.125C8.75 1.60898 9.14102 2 9.625 2ZM9.41992 6.85078C9.55117 6.72773 9.625 6.55547 9.625 6.375C9.625 6.19453 9.55117 6.02227 9.41992 5.89922L5.48242 2.18047C5.29102 2 5.01211 1.95078 4.77148 2.05469C4.53086 2.15859 4.375 2.39648 4.375 2.65625V4.625H0.875C0.391016 4.625 0 5.01602 0 5.5V7.25C0 7.73398 0.391016 8.125 0.875 8.125H4.375V10.0938C4.375 10.3562 4.53086 10.5914 4.77148 10.6953C5.01211 10.7992 5.29102 10.75 5.48242 10.5695L9.41992 6.85078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirect);
export default __webpack_public_path__ + "static/media/redirect.724d551e7774e499f71b9cfe8b04b9c9.svg";
export { ForwardRef as ReactComponent };